<div class="w-full h-10 bg-lugano-gray flex justify-between items-center">

  <div class="w-1/3 h-full px-4 flex justify-start items-center">
    @if (currentMap === 'topview' && !is3dView) {
    <app-menu class="h-full"></app-menu>
    }
  </div>

  <div class="w-1/3 h-full px-4 flex justify-center items-center">
    <app-neighbors [side]="'L'"></app-neighbors>
    <app-selected-node></app-selected-node>
    <app-neighbors [side]="'R'"></app-neighbors>
  </div>

  <div class="w-1/3 h-full px-4 flex justify-end items-center">
    @if (currentMap === 'topview' && !is3dView) {
    <app-search></app-search>
    }
  </div>

</div>